import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeletePropertyPayload } from '@app-store/slices/properties/delete'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IDeletePropertyPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.properties.delete

function* deletePropertySagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.delete(`/attachments/properties/${payload.propertyId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess()
            yield notification.success({
                message: `Property deleted successfully.`
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deletePropertySaga(): any {
    yield takeLatest<TaskAction>(onRequest, deletePropertySagaTask)
}

export default deletePropertySaga
